export default __webpack_public_path__ + "static/Saira-ExtraLight-4ae9884a5b75235800453cde7f35436d.woff2";